class LazyVideoLoader {
  constructor() {
    this.observer = null;
    this.init();
  }
  init() {
    if (!("IntersectionObserver" in window)) {
      this.loadAll();
      return;
    }
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.load(entry.target);
            this.observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "50px 0px", threshold: 0.1 }
    );
    document.querySelectorAll("video.lazy-video").forEach((v) => this.observer.observe(v));
  }
  load(video) {
    if (video.dataset.poster) {
      video.poster = video.dataset.poster;
      delete video.dataset.poster;
    }
    video.querySelectorAll("source[data-src]").forEach((s) => {
      s.src = s.dataset.src;
      s.removeAttribute("data-src");
    });
    video.load();
    video.classList.replace("lazy-video", "video-loaded");
    if (video.hasAttribute("data-autoplay")) {
      video.muted = true;
      video.play().catch(() => {});
    }
  }
  loadAll() {
    document.querySelectorAll("video.lazy-video").forEach((v) => this.load(v));
  }
  add(video) {
    this.observer ? this.observer.observe(video) : this.load(video);
  }
}
function triggerAutoplayVideos() {
  document.querySelectorAll("video[autoplay]").forEach((v) => {
    if (v.closest(".ablyft-gallery-slide")) {
      return;
    }
    v.muted = true;
    v.play().catch(() => {});
  });
}
function initAblyftGalleryVideos() {
  const videos = document.querySelectorAll(".ablyft-gallery-slide video");
  if (!videos.length) {
    return;
  }
  const play = (v) => {
    v.muted = true;
    v.play().catch(() => {});
  };
  if (!("IntersectionObserver" in window)) {
    videos.forEach(play);
    return;
  }
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          play(entry.target);
        } else {
          entry.target.pause();
          entry.target.currentTime = 0;
        }
      });
    },
    { threshold: 0.5 }
  );
  videos.forEach((v) => observer.observe(v));
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    new LazyVideoLoader();
    triggerAutoplayVideos();
    initAblyftGalleryVideos();
  });
} else {
  new LazyVideoLoader();
  triggerAutoplayVideos();
  initAblyftGalleryVideos();
}
